<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="posiciones"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <h2>Posiciones Arancelarias</h2>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="primary" 
                dark 
                class="mb-2" 
                v-bind="attrs" 
                v-on="on">
                  Nueva
              </v-btn>
            </template>
            <v-card light>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Nombre"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.identificador"
                        label="Identificador"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.derecho"
                        label="Derecho"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.estadistica"
                        label="Estadistica"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.impuesto_interno"
                        label="Impuesto Interno"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.iva"
                        label="Iva [%]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <!-- dialog-csv -->
          <v-dialog v-model="dialogCSVLoad" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                color="success" 
                dark 
                class="mb-2 ml-2"
                v-bind="attrs" 
                v-on="on">
                Cargar CSV
              </v-btn>
            </template>

            <v-card
              color="grey lighten-4"
              light
            >
              <v-card-title>
                <span class="headline">Cargar datos desde archivo csv</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="12" sm="6" md="4">
                      <vue-csv-import
                        v-model="csv"
                        :map-fields="['name', 'identificador', 'derecho', 'estadistica', 'iva', 'impuesto_interno', 'fecha']"
                        autoMatchFields
                        headers= false
                        buttonClass = "v-btn v-btn--contained theme--light v-size--default primary"
                        canIgnore
                        >
                    
                        <template slot="error">
                            Formato de archivo invalido
                        </template>
                    
                        <template slot="thead">
                            <tr>
                                <th>Posiciones</th>
                                <th>Columna csv</th>
                            </tr>
                        </template>
                    
                        <template slot="next" slot-scope="{load}">
                          <v-row>
                            <v-col cols="12" lg="12" sm="6">
                              <v-btn 
                                color="primary" 
                                @click.prevent="load"
                                block
                              >
                              Procesar archivo
                              </v-btn>

                            </v-col>
                          </v-row>
                        </template>
                      </vue-csv-import>

                      <v-divider></v-divider>
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="csv"
                          sort-by="name"
                          class="elevation-1"
                          :items-per-page="15"
                        >
                          <!-- <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                              mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteItem(item)">
                              mdi-delete
                            </v-icon>
                          </template> -->
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="closeCSVLoad"
                  >Cancelar</v-btn
                >
                <v-btn color="success" @click="csvSave">Cargar Información</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- dialog-csv -->


            <v-dialog v-model="dialogDelete" max-width="800px">
              <v-card
                light
                >
                <v-card-title class="headline">
                  ¿Está seguro que desea borrar: {{editedItem.name}}?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                  <v-btn color="red darken-1" text @click="deleteItemConfirm">Borrar</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>


import { mapState, mapActions } from "vuex";
// import Axios from "axios";
// import {postPosiciones, putPosiciones, deletePosiciones} from "../store/api";
import { VueCsvImport } from 'vue-csv-import';

export default {
  components: { VueCsvImport },
  data: () => ({
    autoMatchFields: true,
    canIgnore: true,
    dialog: false,
    dialogDelete: false,
    dialogCSVLoad: false,
    csv: [],
    parseCsv: true,
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Identificador", value: "identificador", align: "center"},

      { text: "Derecho", value: "derecho", align: "center"},
      { text: "Estadistica", value: "estadistica", align: "center"},
      { text: "Impuesto Interno", value: "impuesto_interno", align: "center"},
      { text: "Iva [%]", value: "iva", sortable: false, align: "center"},
      { text: "Acciones", value: "actions", sortable: false, align: "center"},
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      identificador: "0",
      derecho: 0,
      estadistica: 0,
      impuesto_interno: 0,
      iva: 0,
    },
    defaultItem: {
      name: "",
      identificador: "0",
      derecho: 0,
      estadistica: 0,
      impuesto_interno: 0,
      iva: 0,
    },
  }),

  computed: {
    ...mapState("posiciones", ["posiciones", 'accessToken']),
    formTitle() {
      return this.editedIndex === -1 ? "Crear" : "Editar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete (val) {
        val || this.closeDelete()
      },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions("posiciones", ["listPosiciones", "putPosiciones", "postPosiciones", "deletePosiciones", "DO_LOGOUT"]),

    initialize() {
      // this.listPosiciones(this.accessToken);
      this.listPosiciones();
    },

    editItem(item) {
      this.editedIndex = this.posiciones.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
        this.editedIndex = this.posiciones.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialogDelete = true;        
    },

    deleteItemConfirm () {
      this.posiciones.splice(this.editedIndex, 1)
      this.closeDelete();
      // deletePosiciones(this.editedItem, this.accessToken);
      this.deletePosiciones(this.editedItem);
    },


    // deleteItem(item) {
    //   const index = this.posiciones.indexOf(item);
    //   confirm("¿Está seguro que quiere eliminarlo?") &&
    //     this.posiciones.splice(index, 1);
    //     console.log('eliminar:', this.posiciones.splice(index, 1));
    //     deletePosiciones();




    // },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    
    closeCSVLoad () {
        this.dialogCSVLoad = false;
      },

    csvSave() {
      this.csv.forEach(element => {
        for (const e in element) {element[e] == '' ? element[e] = '0' : element[e]}

        const elementName = element.name;
        const iDs = this.posiciones.filter(posicion => posicion.name == elementName);

        if (iDs.length == 0 ) {
          console.log(element);
          this.postPosiciones(element);
        } else {
          for (const posicion of iDs) {            
            this.putPosiciones(Object.assign(element, posicion.id));
          }
        }
      });
      this.initialize();
      this.dialogCSVLoad = false;
      this.csv = [];
    },

    save() {
      if (this.editedIndex > -1) {
        this.putPosiciones(Object.assign(this.posiciones[this.editedIndex], this.editedItem));
      } else {
        this.posiciones.push(this.editedItem);
        this.postPosiciones(this.editedItem);
        }
        // 
      this.close();
    },
  },
};
</script>